import event from '@/event-bus/event';

export default {
    name: 'gt-progress',
    mixins: [],
    extends: {},
    components: {},
    props: {},
    data() { 
        return {
            loading: false,
            value: 1,
            msg: '',
            max: 100,
        }; 
    },
    computed: {},
    watch: {},
    created() {
        this.$bus.$on(event.progress, (param) => {
            this.loading = true;
            this.value = param.value;
            this.msg = param.msg;
        }),
        this.$bus.$on(event.progressClose, () => {
            this.loading = false;
            this.msg = '';
            this.value = 1;
        }),
        this.$bus.$on(event.progressValue, (value) => {
            this.loading = true;
            this.value = value;
        })
    },
    mounted() {},
    updated() {},
    beforeDestroy() {},
    methods: {},
  };
  


// WEBPACK FOOTER //
// ./src/components/service/progress/gt-progress.js